import "./Style.scss";
import EditableDetail from "./EditableDetail";

export { EditableDetail };
